import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NewsItem } from '../models/news';
import { FileItem } from '../models/file';

interface ApiResponse<T> {
  success: boolean;
  message: string;
  data?: T;
}

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  private apiUrl = window.location.hostname === 'localhost'
    ? 'http://localhost:3000/api'  // Development: direct to backend
    : '/api';  // Production: use relative URL (proxied by Nginx)

  constructor(private http: HttpClient) {}

  // News management
  createNews(news: Partial<NewsItem>): Observable<ApiResponse<NewsItem>> {
    return this.http.post<ApiResponse<NewsItem>>(`${this.apiUrl}/news`, news);
  }

  updateNews(index: number, news: Partial<NewsItem>): Observable<ApiResponse<NewsItem>> {
    return this.http.put<ApiResponse<NewsItem>>(`${this.apiUrl}/news/${index}`, news);
  }

  deleteNews(index: number): Observable<ApiResponse<NewsItem>> {
    return this.http.delete<ApiResponse<NewsItem>>(`${this.apiUrl}/news/${index}`);
  }

  // File management
  uploadFile(file: File, category: string, title: string, description: string): Observable<ApiResponse<FileItem>> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('category', category);
    formData.append('title', title);
    formData.append('description', description);

    return this.http.post<ApiResponse<FileItem>>(`${this.apiUrl}/files/upload`, formData);
  }

  deleteFile(category: string, filename: string): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.apiUrl}/files/${category}/${filename}`);
  }
}
